import { Button } from '@repo/ui/Button';
import { Loader } from '@repo/ui/Loader';
import { Text } from '../Language/Language';
import s from './ReturnArtifacts.module.css';
import type { SubmitStatus } from '../../graphql/mutation/submit';
import type { PollingStatus } from '../Complete/useLabelPolling';
import type { DeliveryMethod, ReturnArtifact } from './types';
import { pdxEvent } from '../../utils/noflake';

export const ReturnLabelButton = ({
  label,
  deliveryMethod,
  status,
  isMobile,
  isPolling,
  isError,
}: {
  label?: ReturnArtifact;
  deliveryMethod?: DeliveryMethod;
  status: SubmitStatus;
  pollingStatus?: PollingStatus;
  isMobile: boolean;
  isPolling: boolean;
  isError: boolean;
}) => {
  const labelUrl = label?.url;
  const packagingOption = deliveryMethod?.packagingOption;

  const handleClick = () => {
    pdxEvent({
      event_category: 'user_action',
      event_type: 'click',
      event_value: 'return_label',
    });
    if (labelUrl) {
      window.open(labelUrl, '_blank', 'noreferrer');
    }
  };

  const pollingLabels = [
    `pdx.confirmation.${status?.toLowerCase()}.pssl.${packagingOption?.toLowerCase()}.loading`,
    `pdx.confirmation.pssl.${packagingOption?.toLowerCase()}.loading`,
    `pdx.confirmation.pssl.loading`,
  ];
  const completeLabels = [
    `pdx.confirmation.${status?.toLowerCase()}.pssl.${packagingOption?.toLowerCase()}.complete`,
    `pdx.confirmation.${status?.toLowerCase()}.pssl.${packagingOption?.toLowerCase()}`,
    `pdx.confirmation.pssl.${packagingOption?.toLowerCase()}.complete`,
    `pdx.confirmation.pssl.${packagingOption?.toLowerCase()}`,
    `pdx.confirmation.pssl.complete`,
    `pdx.confirmation.pssl`,
  ];

  return (
    <Button
      variant="primary"
      onClick={handleClick}
      size={isMobile ? 'md' : 'lg'}
      isFullWidth={true}
      className={s.psslButton}
      disabled={isPolling || isError}
    >
      {isPolling && <Loader />}
      <Text langKey={isPolling ? pollingLabels : completeLabels} />
    </Button>
  );
};
